(function () {
  const EMPTY = "—";

  let documentListenersBound = false;

  function textOrDash(v) {
    if (v == null || v === "") return EMPTY;
    return String(v);
  }

  function parseMap(root) {
    const el = root.querySelector("[data-compare-products-json]");
    if (!el || !el.textContent.trim()) return null;
    try {
      return JSON.parse(el.textContent);
    } catch {
      return null;
    }
  }

  function applyProduct(card, data) {
    if (!data) return;

    const title = card.querySelector("[data-compare-title]");
    if (title) title.textContent = data.title || "";

    const price = card.querySelector("[data-compare-price]");
    if (price) price.textContent = data.price || "";

    const link = card.querySelector("[data-compare-link]");
    if (link && data.url) link.href = data.url;

    const img = card.querySelector("[data-compare-image]");
    const ph = card.querySelector("[data-compare-placeholder]");
    if (data.featured_image) {
      if (img) {
        img.src = data.featured_image;
        img.srcset = "";
        img.removeAttribute("sizes");
        img.alt = data.title || "";
        img.removeAttribute("hidden");
      }
      if (ph) ph.setAttribute("hidden", "");
    } else {
      if (img) {
        img.src = "";
        img.removeAttribute("src");
        img.setAttribute("hidden", "");
      }
      if (ph) ph.removeAttribute("hidden");
    }

    const specs = {
      weight_capacity: data.weight_capacity,
      height: data.height,
      adjustment_type: data.adjustment_type,
      caster_size: data.caster_size,
      accessories: data.accessories,
    };

    // Object.keys(specs).forEach((key) => {
    //   const node = card.querySelector(`[data-compare-spec="${key}"]`);
    //   if (node) node.textContent = textOrDash(specs[key]);
    // });
    const specsContainer = card.querySelector(".vp-product-compare-card__specs");
    if (specsContainer && data.specs) {
      specsContainer.innerHTML = Object.entries(data.specs)
        .map(
          ([key, val]) => `
      <div class="vp-product-compare-card__spec-row">
        <span class="vp-product-compare-card__spec-label">${key.replace(/_/g, " ")}</span>
        <span class="vp-product-compare-card__spec-value" data-compare-spec="${key}">${val || "—"}</span>
      </div>
    `,
        )
        .join("");
    }

    card.querySelectorAll("[data-compare-option]").forEach((btn) => {
      const v = btn.getAttribute("data-value");
      btn.setAttribute("aria-selected", v === String(data.id) ? "true" : "false");
    });
  }

  function closeDropdown(dropdown) {
    if (!dropdown) return;
    const trigger = dropdown.querySelector("[data-compare-dropdown-trigger]");
    const panel = dropdown.querySelector("[data-compare-dropdown-panel]");
    dropdown.classList.remove("is-open");
    if (panel) panel.hidden = true;
    if (trigger) trigger.setAttribute("aria-expanded", "false");
  }

  function closeAllCompareDropdowns(except) {
    document.querySelectorAll("[data-compare-dropdown].is-open").forEach((d) => {
      if (d !== except) closeDropdown(d);
    });
  }

  function openDropdown(dropdown) {
    closeAllCompareDropdowns(dropdown);
    const trigger = dropdown.querySelector("[data-compare-dropdown-trigger]");
    const panel = dropdown.querySelector("[data-compare-dropdown-panel]");
    dropdown.classList.add("is-open");
    if (panel) panel.hidden = false;
    if (trigger) trigger.setAttribute("aria-expanded", "true");
  }

  function bindDocumentListeners() {
    if (documentListenersBound) return;
    documentListenersBound = true;

    document.addEventListener("click", (e) => {
      document.querySelectorAll("[data-compare-dropdown].is-open").forEach((dropdown) => {
        if (!dropdown.contains(e.target)) closeDropdown(dropdown);
      });
    });

    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      document.querySelectorAll("[data-compare-dropdown].is-open").forEach(closeDropdown);
    });
  }

  function bindDropdown(card, select, map) {
    const dropdown = card.querySelector("[data-compare-dropdown]");
    if (!dropdown) return;

    const trigger = dropdown.querySelector("[data-compare-dropdown-trigger]");
    const panel = dropdown.querySelector("[data-compare-dropdown-panel]");
    if (!trigger || !panel) return;

    bindDocumentListeners();

    trigger.addEventListener("click", (e) => {
      e.stopPropagation();
      if (panel.hidden) {
        openDropdown(dropdown);
      } else {
        closeDropdown(dropdown);
      }
    });

    panel.querySelectorAll("[data-compare-option]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        const id = btn.getAttribute("data-value");
        if (!id) return;
        if (select.value !== id) {
          select.value = id;
          const data = map[id];
          applyProduct(card, data);
        }
        closeDropdown(dropdown);
      });
    });
  }

  function init(root) {
    if (!root || root.dataset.compareInited === "1") return;
    root.dataset.compareInited = "1";

    const map = parseMap(root);
    if (!map) return;

    root.querySelectorAll("[data-compare-card]").forEach((card) => {
      const select = card.querySelector("[data-compare-select]");
      if (!select) return;

      select.addEventListener("change", () => {
        const id = select.value;
        const data = map[id];
        applyProduct(card, data);
      });

      bindDropdown(card, select, map);
    });
  }

  function initAll() {
    document.querySelectorAll(".vp-product-compare").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (e) => {
    const root = e.target?.querySelector?.(".vp-product-compare");
    if (root) init(root);
  });
})();
